import React from 'react';

import AuthLayout from 'components/authentication/AuthLayout';
import ResetPasswordForm from 'components/authentication/ResetPasswordForm';


const ResetPasswordPage = ({ match }) => (
  <AuthLayout className="password-recovery-page__component">
    {match.params.key &&
      <ResetPasswordForm confirmationKey={match.params.key} />
    }
  </AuthLayout>
);

export default ResetPasswordPage;
